import { BoxChart } from '../../../../../../components/Charts/BoxChart'
import { GetExecutionCollectionGroupedByTimeQuery } from '@indigohive/cogfy-types/endpoints/getExecutionCollectionGroupedByTime'
import { GroupByTime, UUID } from '@indigohive/cogfy-types'
import { HeaderComponent } from './HeaderComponent'
import { LineChart } from '../../../../../../components/Charts/LineChart'
import { useCogfy } from '../../../../../../hooks'
import { useQuery } from '@tanstack/react-query'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

export type TasksUsageChartProps = {
  startDate?: Date
  endDate?: Date
  collectionId?: string
}

export function TasksUsageChart (props: TasksUsageChartProps) {
  const { startDate, endDate, collectionId } = props

  const { t } = useTranslation()
  const cogfy = useCogfy()

  const [groupBy, setGroupBy] = useState<GroupByTime>('hour')
  const query: GetExecutionCollectionGroupedByTimeQuery = {
    timezoneOffset: new Date().getTimezoneOffset() / -60,
    groupBy,
    startDate,
    endDate,
    collectionId: collectionId as UUID | undefined
  }

  const getTasks = useQuery({
    queryKey: ['getExecutionCollectionGroupedByTime', query],
    queryFn: ({ signal }) => cogfy.getExecutionCollectionGroupedByTime(query, { signal })
  })

  const labels = getTasks.data?.flatMap(row => row.label)

  const dataTasks = {
    labels,
    datasets: [
      {
        label: 'Tasks',
        data: getTasks.data?.flatMap(item => Math.ceil(item.tasks)) || [],
        borderColor: '#37cdbe',
        backgroundColor: '#37cdbe'
      }
    ]
  }

  return (
    <BoxChart
      title={t('workspaceUsagePage:Tasks by period')}
      headerComponent={
        <HeaderComponent
          groupBy={groupBy}
          setGroupBy={setGroupBy}
        />}
    >
      <LineChart
        className="min-h-[400px]"
        data={dataTasks}
        loading={getTasks.isLoading}
        error={getTasks.isError}
      />
    </BoxChart>
  )
}
